module.exports = __webpack_public_path__ + "img/safe.85d4cf3d.svg";